/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cta_SubtitleInputs */

const en_pc_cta_subtitle = /** @type {(inputs: Pc_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install the desktop app, or open it in your browser in a few seconds.`)
};

const zh_pc_cta_subtitle = /** @type {(inputs: Pc_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装桌面版，或几秒钟内在浏览器中打开。`)
};

/**
* | output |
* | --- |
* | "Install the desktop app, or open it in your browser in a few seconds." |
*
* @param {Pc_Cta_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cta_subtitle = /** @type {((inputs?: Pc_Cta_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cta_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cta_subtitle(inputs)
	return zh_pc_cta_subtitle(inputs)
});
export { pc_cta_subtitle as "pc.cta.subtitle" }